import React from 'react';
import { Status } from '@breakroom-nx/helpers';
import { closeModal, useAppDispatch } from '@breakroom-nx/redux';
import {
  Alert as AlertNative,
  Box,
  CloseIcon,
  Collapse,
  HStack,
  IconButton,
  Text,
  VStack,
} from 'native-base';

export const Alert = (props: any) => {
  const status: Status = props.status;
  const title: string = props.title;
  const description: string = props.description;

  const [showing, setShowingState] = React.useState(true);
  const dispatch = useAppDispatch();

  return (
    <Box w="90%" alignSelf="center" position="absolute" top={5} zIndex={9999}>
      <Collapse
        isOpen={showing}
        pb={10}
        onAnimationEnd={() => {
          dispatch(closeModal());
        }}
      >
        <AlertNative w="100%" status={status ?? 'error'} variant="left-accent">
          <VStack space={2} flexShrink={1} w="100%">
            <HStack flexShrink={1} space={2} justifyContent="space-between">
              <HStack space={2} flexShrink={1}>
                <AlertNative.Icon mt="1" />
                <VStack>
                  <Text
                    fontSize="lg"
                    color="coolGray.800"
                    fontFamily="body"
                    fontStyle="normal"
                    fontWeight={600}
                  >
                    {title ?? 'An error occurred, please try again later.'}
                  </Text>
                  {description ? (
                    <Text
                      fontSize="md"
                      color="coolGray.800"
                      fontFamily="body"
                      fontStyle="normal"
                      fontWeight={300}
                      lineHeight="18"
                    >
                      {description}
                    </Text>
                  ) : null}
                </VStack>
              </HStack>
              <IconButton
                onPress={() => setShowingState(false)}
                variant="unstyled"
                icon={<CloseIcon size="3" color="coolGray.600" />}
              />
            </HStack>
          </VStack>
        </AlertNative>
      </Collapse>
    </Box>
  );
};
